import React from "react";
import PropTypes from 'prop-types';
import BlockContent from "./blockContent";
import SideBySideSegment from "./serializers/sideBySideSegment";
import TitleSegment from "./serializers/titleSegment";
import FaqSegment from "./serializers/faqSegment";
import PricingSegment from "./serializers/pricingSegment";
import ComparisonSegment from "./serializers/comparisonSegment";
import BuiltForSegment from "./serializers/builtForSegment";
import FeatureGridSegment from "./serializers/featuregridSegment";
import VideoSegment from "./serializers/videoSegment";

const SegmentRenderer = ({ content }) => {
  if (content) {
    return (
      content.map((segment) => {
        switch (segment._type) {
          case "textSegment":
            return (
              <BlockContent blocks={segment.text} key={segment._key} />
            )
          case "sideBySideSegment":
            return (
              <SideBySideSegment segment={segment} key={segment._key} />
            )
          case "titleSegment":
            return (
              <TitleSegment segment={segment} key={segment._key} />
            )
          case "faqSegment":
            return (
              <FaqSegment segment={segment} key={segment._key} />
            )
          case "pricingSegment":
            return (
              <PricingSegment segment={segment} key={segment._key} />
            )
          case "comparisonSegment":
            return (
              <ComparisonSegment segment={segment} key={segment._key} />
            )
          case "builtforSegment":
            return (
              <BuiltForSegment segment={segment} key={segment._key} />
            )
          case "featuregridSegment":
            return (
              <FeatureGridSegment segment={segment} key={segment._key} />
            )
          case "videoSegment":
            return (
              <VideoSegment segment={segment} key={segment._key} />
            )
          default: return null
        }
      })
    )
  }

  return null
};

export default SegmentRenderer;

SegmentRenderer.propTypes = {
  content: PropTypes.array.isRequired
}